module.exports = __webpack_public_path__ + "fonts/gothica1-medium-webfont.a008f49.woff2";